<template>
  <div class="upload-successful-screen">
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_6829_471)">
      <path d="M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z" fill="white"/>
      <path d="M60 113C89.2711 113 113 89.2711 113 60C113 30.7289 89.2711 7 60 7C30.7289 7 7 30.7289 7 60C7 89.2711 30.7289 113 60 113Z" stroke="#D1D1D1" stroke-width="14"/>
      <path d="M33 65.282L53.307 81.878" stroke="#26C786" stroke-width="10" stroke-linecap="round"/>
      <path d="M53.3071 81.878L87.5311 47.5" stroke="#26C786" stroke-width="10" stroke-linecap="round"/>
      </g>
      <defs>
      <clipPath id="clip0_6829_471">
      <rect width="120" height="120" fill="white"/>
      </clipPath>
      </defs>
    </svg>
    <p>{{ $t('Account.UploadCenter.Success') }}</p>
    <v-btn v-if="!allFilesUploaded" class="secondary-btn v-btn error" @click="addMoreFiles">{{ $t('Account.UploadCenter.Success.AddMore') }}</v-btn>
    <v-btn class="primary-btn v-btn theme--light" @click="backToHome">{{ $t('Account.UploadCenter.Success.Done') }}</v-btn>
  </div>
</template>

<script>
export default {
  name: 'UploadSuccessfulScreen',
  props: [
    'allFilesUploaded'
  ],
  methods: {
    addMoreFiles () {
      this.$emit('add-more-files', true)
    },
    backToHome () {
      this.$router.push({ name: 'sports' })
    }
  }
}
</script>

<style scoped>
.upload-successful-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60%;
}
.upload-successful-screen svg {
  margin-bottom: 20px;
}
.upload-successful-screen p {
  text-align: center;
}
.v-btn.secondary-btn :hover {
  background-color: inherit !important;
}
</style>



// WEBPACK FOOTER //
// src/components/account/UploadCenter/UploadSuccessfulScreen.vue